import { render, staticRenderFns } from "./AssigneesDropdown.vue?vue&type=template&id=56651b76&"
import script from "./AssigneesDropdown.vue?vue&type=script&lang=ts&"
export * from "./AssigneesDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports